import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useEffect, useState } from 'react';
import { isCloseForm } from '../lib/Api';

const CloseErrorDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    (async () => {
      const closeForm = await isCloseForm();
      setOpen(closeForm);
    })();
  }, []);

  return (
    <Dialog open={open}>
      <DialogTitle>現在利用できません。</DialogTitle>
      <div className="space-y-4 p-4">
        <p>このフォームは現在利用できません。</p>
      </div>
    </Dialog>
  );
};

export { CloseErrorDialog };
